import { useEffect } from 'react';
import { Modal } from '../ui/Modal';

export function PaymentModal({ open, onClose, iframeUrl, onSuccess, onFail }) {
  useEffect(() => {
    if (!open) return;

    const handler = (e) => {
      if (e.data?.type === 'payment-result') {
        if (e.data.status === 'success') onSuccess?.(e.data);
        else onFail?.(e.data);
        onClose();
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [open, onClose, onSuccess, onFail]);

  return (
    <Modal open={open} onClose={onClose} title="Ödeme" size="xl">
      {iframeUrl ? (
        <iframe
          src={iframeUrl}
          className="w-full"
          style={{ height: '70vh', border: 0 }}
          title="PayTR Ödeme"
        />
      ) : (
        <p className="text-center py-8 text-slate-500">Yükleniyor...</p>
      )}
    </Modal>
  );
}
